import { render } from "./project_menu.vue?vue&type=template&id=888b05a0&scoped=true"
import script from "./project_menu.vue?vue&type=script&lang=js"
export * from "./project_menu.vue?vue&type=script&lang=js"

import "./project_menu.vue?vue&type=style&index=0&id=888b05a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-888b05a0"]])

export default __exports__